<template>
  <BuyReport v-bind="buyButtonProps">
    <template v-slot:caption>
      <div class="sidebar-caption text-center" v-if="monitoringSettings.isActive">
        {{ $t('monitoring.ordered') }}
        <DateRange :start="monitoringSettings.startDate" :end="monitoringSettings.endDate" />
      </div>
    </template>
  </BuyReport>
</template>

<script>
import BuyReport from './BuyReport';
import DateRange from './DateRange';

export default {
  props: ['product', 'monitoringSettings'],
  components: {
    DateRange,
    BuyReport,
  },
  computed: {
    buyButtonProps() {
      return {
        ...this.$attrs,
        product: this.product,
        buttonTitle: this.$t(this.monitoringSettings.isActive ? 'prolong' : 'buy'),
        buttonClass: 'mb-11 mt-7',
        price: this.$priceStartsFrom(this.$price(this.$pricePerPeriod(this.product.subscriptions))),
      };
    },
  },
};
</script>
